

$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });

  // Global orewa-variant-pill click event listener
  $(document).on('click', '.orewa-variant-pill', function(e) {
    var pill = $(this);
    if (pill.prop('disabled')) return;
    
    var variantId = pill.attr('data-variant-id');
    var price = pill.attr('data-price');
    var comparePrice = pill.attr('data-compare-price');
    
    var card = pill.closest('.product-wrapper');
    if (!card.length) return;
    
    card.find('.orewa-variant-pill').removeClass('active');
    pill.addClass('active');
    
    var input = card.find('form.orewa-add-to-cart-form input[name="id"]');
    if (input.length) {
      input.val(variantId);
    }
    
    var priceSpan = card.find('.product-price span');
    if (priceSpan.length) {
      priceSpan.text(price);
    }
    var compareDel = card.find('.product-price del');
    if (compareDel.length) {
      if (comparePrice) {
        compareDel.text(comparePrice).show();
      } else {
        compareDel.hide();
      }
    } else if (comparePrice) {
      $('<del>' + comparePrice + '</del>').insertBefore(priceSpan);
    }

    // Update discount percentage badge
    var badge = card.find('.orewa-discount-badge');
    if (badge.length) {
      if (comparePrice && price) {
        var cleanCompare = parseInt(comparePrice.replace(/[^0-9]/g, ''), 10);
        var cleanPrice = parseInt(price.replace(/[^0-9]/g, ''), 10);
        if (!isNaN(cleanCompare) && !isNaN(cleanPrice) && cleanCompare > cleanPrice) {
          var percent = Math.round(((cleanCompare - cleanPrice) / cleanCompare) * 100);
          badge.text(percent + "% OFF").show();
        } else {
          badge.hide();
        }
      } else {
        badge.hide();
      }
    }
  });

  // Global Ajax Add to Cart form submission with strict debounce & single-in-flight lock
  $(document).on('submit', 'form[action*="/cart/add"]', function(e) {
    e.preventDefault();
    var $form = $(this);
    
    // Prevent duplicate in-flight requests on rapid click or long-press
    if ($form.data('orewa-submitting')) {
      return false;
    }
    $form.data('orewa-submitting', true);

    var $btn = $form.find('[type="submit"], .orewa-btn-add-to-cart, #AddToCart');
    var origText = $btn.html();
    $btn.addClass('loading').prop('disabled', true).attr('disabled', 'disabled');
    if ($btn.hasClass('orewa-btn-add-to-cart')) {
      $btn.text('Adding...');
    }
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $form.serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ($btn.hasClass('orewa-btn-add-to-cart')) {
          $btn.text('Added!');
        }
        
        // Refresh Cart Drawer
        if (window.OrewaCart && typeof window.OrewaCart.fetchAndRender === 'function') {
          window.OrewaCart.fetchAndRender();
        } else if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
          Shopify.getCart(function(cart) {
            if (typeof Shopify.onCartUpdate === 'function') {
              Shopify.onCartUpdate(cart);
            }
          });
        }

        // Open the mini cart drawer and dark overlay
        $('.ltn__utilize-cart-menu').addClass('ltn__utilize-open');
        $('.ltn__utilize-overlay').fadeIn();

        // Release debounce lock after safe delay
        setTimeout(function() {
          $btn.removeClass('loading').prop('disabled', false).removeAttr('disabled').html(origText);
          $form.data('orewa-submitting', false);
        }, 800);
      },
      error: function(xhr, textStatus) {
        $btn.removeClass('loading').prop('disabled', false).removeAttr('disabled').html(origText);
        $form.data('orewa-submitting', false);
        if (typeof Shopify !== 'undefined' && typeof Shopify.onError === 'function') {
          Shopify.onError(xhr, textStatus);
        } else {
          alert('Could not add item to cart. Please try again.');
        }
      }
    });
  });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "headerSection") {
    $this.headerSection();
  }else if($this.data('section') == "SlideshowActivation") {
    $this.find('.ltn__slide-one-active').SlideshowActivation();
  }else if($this.data('section') == "tabWithProduct") {
    $this.find('.ltn__tab-product-slider-one-active').tabWithProduct();
  }else if($this.data('section') == "countdownBanner") {
    $this.countdownBanner();
  }else if($this.data('section') == "featuredCollection") {
    $this.find('.ltn__product-slider-item-four-active').featuredCollection();
  }else if($this.data('section') == "testimonialTab") {
    $this.testimonialTab();
  }else if($this.data('section') == "brandLogo") {
    $this.find('.ltn__brand-logo-active').brandLogo();
  }else if($this.data('section') == "latestBlog") {
    $this.find('.ltn__blog-slider-one-active').latestBlog();
  }else if($this.data('section') == "footerActive") {
    $this.footerActive();
  }else if($this.data('section') == "sliderWithPopupVideo") {
    $this.find('.ltn__slide-one-active').sliderWithPopupVideo();
  }else if($this.data('section') == "serviceSectionTwo") {
    $this.serviceSectionTwo();
  }else if($this.data('section') == "aboutWithContact") {
    $this.aboutWithContact();
  }else if($this.data('section') == "serviceInfoCounter") {
    $this.serviceInfoCounter();
  }else if($this.data('section') == "serviceBlog") {
    $this.find('.ltn__image-slider-3-active').serviceBlog();
  }else if($this.data('section') == "tabWithProduct2") {
    $this.find('.ltn__tab-product-slider-one-active').tabWithProduct2();
  }else if($this.data('section') == "serviceImage") {
    $this.find('.ltn__image-slider-2-active').serviceImage();
  }else if($this.data('section') == "serviceBlogTwo") {
    $this.find('.ltn__image-slider-4-active').serviceBlogTwo();
  }else if($this.data('section') == "popupVideoBanner") {
    $this.popupVideoBanner();
  }else if($this.data('section') == "testimonialSlider") {
    $this.find('.ltn__testimonial-slider-2-active').testimonialSlider();
  }else if($this.data('section') == "slideshowTwoActivation") {
    $this.find('.ltn__slide-one-active').slideshowTwoActivation();
  }else if($this.data('section') == "testimonialSliderThree") {
    $this.find('.ltn__testimonial-slider-3-active').testimonialSliderThree();
  }else if($this.data('section') == "aboutService") {
    $this.aboutService();
  }else if($this.data('section') == "latestBlog2") {
    $this.find('.ltn__blog-slider-one-active').latestBlog2();
  }else if($this.data('section') == "popupVideoBanner2") {
    $this.find('.ltn__slide-one-active').popupVideoBanner2();
  }else if($this.data('section') == "searchInventory2") {
    $this.searchInventory2();
  }else if($this.data('section') == "productTemplate") {
    $this.productTemplate();
  }else if($this.data('section') == "teamSkill") {
    $this.teamSkill();
  }else if($this.data('section') == "contactForm") {
    $this.contactForm();
  }else if($this.data('section') == "ourJourney") {
    $this.ourJourney();
  }else if($this.data('section') == "pricingTable") {
    $this.pricingTable();
  }else if($this.data('section') == "passwordPage") {
    $this.passwordPage();
  }else if($this.data('section') == "featuredProduct") {
    $this.featuredProduct();
  }else if($this.data('section') == "countdownBanner2") {
    $this.countdownBanner2();
  }else if($this.data('section') == "searchInventory3") {
    $this.searchInventory3();
  }else if($this.data('section') == "heroBanner2") {
    $this.heroBanner2();
  }else if($this.data('section') == "slideshowCategoryMenu") {
    $this.find('.ltn__slide-one-active').slideshowCategoryMenu();
  }else if($this.data('section') == "featuredCollectionList2") {
    $this.find('.ltn__small-product-slider-active').featuredCollectionList2();
  }else if($this.data('section') == "categoryList2") {
    $this.find('.ltn__category-slider-active').categoryList2();
  }else if($this.data('section') == "categoryList3") {
    $this.find('.ltn__category-slider-active').categoryList3();
  }else if($this.data('section') == "collectionTemplate") {
    $this.collectionTemplate();
  }else if($this.data('section') == "slideshowThreeActivation") {
    $this.find('.ltn__slide-one-active').slideshowThreeActivation();
  }else if($this.data('section') == "testimonialSliderFour") {
    $this.find('.ltn__testimonial-slider-active').testimonialSliderFour();
  }else if($this.data('section') == "allCategoryList") {
    $this.find('.ltn__category-slider-active').allCategoryList();
  }else{}   
}

// 36. Header menu sticky
$.fn.headerSection = function() {
  /* --------------------------------------------------------
            1. Variables
        --------------------------------------------------------- */
  var $window = $(window),
      $body = $('body');
  
  $(window).on('scroll',function() {    
    var scroll = $(window).scrollTop();
    if (scroll < 445) {
      $(".ltn__header-sticky").removeClass("sticky-active");
    } else {
      $(".ltn__header-sticky").addClass("sticky-active");
    }
  }); 

  /* --------------------------------------------------------
            2. Mobile Menu
        --------------------------------------------------------- */
  /* ---------------------------------
            Utilize Function 
        ----------------------------------- */
  (function () {
    var $ltn__utilizeToggle = $('.ltn__utilize-toggle'),
        $ltn__utilize = $('.ltn__utilize'),
        $ltn__utilizeOverlay = $('.ltn__utilize-overlay'),
        $mobileMenuToggle = $('.mobile-menu-toggle');
    $ltn__utilizeToggle.on('click', function (e) {
      e.preventDefault();
      var $this = $(this),
          $target = $this.attr('href');
      $body.addClass('ltn__utilize-open');
      $($target).addClass('ltn__utilize-open');
      $ltn__utilizeOverlay.fadeIn();
      if ($this.parent().hasClass('mobile-menu-toggle')) {
        $this.addClass('close');
      }
    });
    $('.ltn__utilize-close, .ltn__utilize-overlay').on('click', function (e) {
      e.preventDefault();
      $body.removeClass('ltn__utilize-open');
      $ltn__utilize.removeClass('ltn__utilize-open');
      $ltn__utilizeOverlay.fadeOut();
      $mobileMenuToggle.find('a').removeClass('close');
    });
  })();

  /* ------------------------------------
            Utilize Menu
        ----------------------------------- */
  function mobileltn__utilizeMenu() {
    var $ltn__utilizeNav = $('.ltn__utilize-menu, .overlay-menu'),
        $ltn__utilizeNavSubMenu = $ltn__utilizeNav.find('.sub-menu');

    /*Add Toggle Button With Off Canvas Sub Menu*/
    $ltn__utilizeNavSubMenu.parent().prepend('<span class="menu-expand"></span>');

    /*Category Sub Menu Toggle*/
    $ltn__utilizeNav.on('click', 'li a, .menu-expand', function (e) {
      var $this = $(this);
      if ($this.attr('href') === '#' || $this.hasClass('menu-expand')) {
        e.preventDefault();
        if ($this.siblings('ul:visible').length) {
          $this.parent('li').removeClass('active');
          $this.siblings('ul').slideUp();
          $this.parent('li').find('li').removeClass('active');
          $this.parent('li').find('ul:visible').slideUp();
        } else {
          $this.parent('li').addClass('active');
          $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
          $this.closest('li').siblings('li').find('ul:visible').slideUp();
          $this.siblings('ul').slideDown();
        }
      }
    });
  }
  mobileltn__utilizeMenu();

  /* --------------------------------------------------------
            3. Mega Menu
        --------------------------------------------------------- */
  $('.mega-menu').each(function(){
    if($(this).children('li').length){
      var ulChildren = $(this).children('li').length;
      $(this).addClass('column-'+ulChildren)
    }
  });


  /* Remove Attribute( href ) from sub-menu title in mega-menu */
  /*
        $('.mega-menu > li > a').removeAttr('href');
        */


  /* Mega Munu  */
  // $(".mega-menu").parent().css({"position": "inherit"});
  $(".mega-menu").parent().addClass("mega-menu-parent");


  /* Add space for Elementor Menu Anchor link */
  $( window ).on( 'elementor/frontend/init', function() {
    elementorFrontend.hooks.addFilter( 'frontend/handlers/menu_anchor/scroll_top_distance', function( scrollTop ) {
      return scrollTop - 75;
    });
  });


  /* ---------------------------------------------------------
            4. One Page Navigation ( jQuery Easing Plugin )
        --------------------------------------------------------- */
  // jQuery for page scrolling feature - requires jQuery Easing plugin
  $(function() {
    $('a.page-scroll').bind('click', function(event) {
      var $anchor = $(this);
      $('html, body').stop().animate({
        scrollTop: $($anchor.attr('href')).offset().top
      }, 1500, 'easeInOutExpo');
      event.preventDefault();
    });
  });


  /* --------------------------------------------------------
            5. Toogle Search
        -------------------------------------------------------- */
  // Handle click on toggle search button
  $('.header-search-1').on('click', function() {
    $('.header-search-1, .header-search-1-form').toggleClass('search-open');
    return false;
  });
  
  $(".ltn__currency-menu > ul > li > a").removeAttr("href");

  // Language and Currency Activation
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('localization-form', LocalizationForm);

};

// 15. Slider One Active
$.fn.SlideshowActivation = function() {
  var SlideshowActivation_slider = this;
  SlideshowActivation_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
};

// 17. Tab Product Slider One
$.fn.tabWithProduct = function() {
  var tabWithProduct_slider = this;
  tabWithProduct_slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// Countdown Banner Active
$.fn.countdownBanner = function() {
  /* --------------------------------------------------------
            29. Countdown
        --------------------------------------------------------- */
  $('[data-countdown].ltn__countdown-1').each(function () {

    var $this = $(this),
        finalDate = $(this).data('countdown');
    if (!$this.hasClass('countdown-full-format')) {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%D</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    } else {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%Y</h6><p>Years</p></div> <div class="single"><h6>%m</h6><p>Months</p></div> <div class="single"><h6>%W</h6><p>Weeks</p></div> <div class="single"><h6>%d</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    }

  });
};

// 16. Product Slider One
$.fn.featuredCollection = function() {
  var $featuredCollection_slider = this;
  $featuredCollection_slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// 36. Testimonial Slider 4 Active
$.fn.testimonialTab = function() {
  var $ltn__testimonial_quote_slider = $('.ltn__testimonial-slider-4-active');
  $ltn__testimonial_quote_slider.slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    fade: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 992,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 580,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      }
    ]
  });

  /* have to write code for bind it with static images */
  $ltn__testimonial_quote_slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var liIndex = nextSlide + 1;
    var slideImageliIndex = (slick.slideCount == liIndex) ? liIndex - 1 : liIndex;
    var cart = $('.ltn__testimonial-slider-4 .slick-slide[data-slick-index="' + slideImageliIndex + '"]').find('.ltn__testimonial-image');
    var imgtodrag = $('.ltn__testimonial-quote-menu li:nth-child(' + liIndex + ')').find("img").eq(0);
    if (imgtodrag) {
      AnimateTestimonialImage(imgtodrag, cart)
    }
  });

  /* have to write code for bind static image to slider accordion to slide index of images */
  $(document).on('click', '.ltn__testimonial-quote-menu li', function (e) {
    var el = $(this);
    var elIndex = el.prevAll().length;
    $ltn__testimonial_quote_slider.slick('slickGoTo', elIndex);
    var cart = $('.ltn__testimonial-slider-4 .slick-slide[data-slick-index="' + elIndex + '"]').find('.ltn__testimonial-image');
    var imgtodrag = el.find("img").eq(0);
    if (imgtodrag) {
      AnimateTestimonialImage(imgtodrag, cart)
    }

  });
  
  function AnimateTestimonialImage(imgtodrag, cart) {
    var imgclone = imgtodrag.clone().offset({
      top: imgtodrag.offset().top,
      left: imgtodrag.offset().left
    }).css({
      'opacity': '0.5',
      'position': 'absolute',
      'height': '130px',
      'width': '130px',
      'z-index': '100'
    }).addClass('quote-animated-image').appendTo($('body')).animate({
      'top': cart.offset().top + 10,
      'left': cart.offset().left + 10,
      'width': 130,
      'height': 130
    }, 300);


    imgclone.animate({
      'visibility': 'hidden',
      'opacity': '0'
    }, function () {
      $(this).remove()
    });
  }
};

// 27. Brand Logo Active
$.fn.brandLogo = function() {
  var $brandLogoSlider = this;
  $brandLogoSlider.slick({
    rtl: false,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// 18. Blog Slider One Active
$.fn.latestBlog = function() {
  var $latestBlogSlider = this;
  $latestBlogSlider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Footer Active
$.fn.footerActive = function() {
  // 6. Current Year Copyright area
  $(".current-year").text((new Date).getFullYear());
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });

  $('.widget-collapse .footer-title').on("click", function(){
    $(this).siblings('.widget-collapse-hide').slideToggle();
    $(this).toggleClass('widget-collapse-show');
  });
  
};

// 15. Slider One Active
$.fn.sliderWithPopupVideo = function() {
  var $sliderWithPopupVideo_slider = this;
  $sliderWithPopupVideo_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
};

// Service Two Active
$.fn.serviceSectionTwo = function() {
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// About with Contact Active
$.fn.aboutWithContact = function() {
  // 10. Nice Select
  $('.get-a-quote-wrap select').niceSelect();
};

// Counter Active
$.fn.serviceInfoCounter = function() {
  /* --------------------------------------------------------
            30. Counter Up
        --------------------------------------------------------- */
  // $('.ltn__counter').counterUp();

  $('.counter').counterUp({
    delay: 10,
    time: 2000
  });
  $('.counter').addClass('animated fadeInDownBig');  
  $('h3').addClass('animated fadeIn');
};

// 25. Image Slide - 3 Active
$.fn.serviceBlog = function() {
  var $serviceBlogSlider = this;
  $serviceBlogSlider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    centerMode: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
  
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
};

// Tab Product Slider Two
$.fn.tabWithProduct2 = function() {
  var $tabWithProduct_slider = this;
  $tabWithProduct_slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// 25. Image Slide - 3 Active
$.fn.serviceImage = function() {
  var $serviceImageSlider = this;
  $serviceImageSlider.slick({
    rtl: false,
    arrows: true,
    loop: false,
    dots: false,
    infinite: true,
    speed: 300,
    centerMode: true,
    centerPadding: '80px',
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
  
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
};

// 26. Image Slide - 4 Active
$.fn.serviceBlogTwo = function() {
  var $serviceBlogTwoSlider = this;
  $serviceBlogTwoSlider.slick({
    rtl: false,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    centerMode: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
  
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
};

// 18. Blog Slider One Active
$.fn.popupVideoBanner = function() {
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
  
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// 20. Testimonial Slider - 2 Active
$.fn.testimonialSlider = function() {
  var $testimonialSliderActive = this;
  $testimonialSliderActive.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// Slider Two Active
$.fn.slideshowTwoActivation = function() {
  var $slideshowTwoActivation_slider = this;
  $slideshowTwoActivation_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Slider Two Active
$.fn.testimonialSliderThree = function() {
  var $testimonialSliderThree_slider = this;
  $testimonialSliderThree_slider.slick({
    arrows: true,
    centerMode: true,
    centerPadding: '80px',
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// About Service Active
$.fn.aboutService = function() {
  /* --------------------------------------------------------
            35. Parallax active ( About Section  )
        -------------------------------------------------------- */
  /* 
        > 1 page e 2 ta call korle 1 ta kaj kore 
        */
  if($('.ltn__parallax-effect-active').length){
    var scene = $('.ltn__parallax-effect-active').get(0);
    var parallaxInstance = new Parallax(scene);
  }
};

// 18. Blog Slider Two Active
$.fn.latestBlog2 = function() {
  var $latestBlog2Slider = this;
  $latestBlog2Slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// 18. Blog Slider One Active
$.fn.popupVideoBanner2 = function() {
  var $popupVideoBanner2_slider = this;
  $popupVideoBanner2_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });

  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Search Inventory 2 Active
$.fn.searchInventory2 = function() {
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Search Inventory 3 Active
$.fn.searchInventory3 = function() { 
  var SlideshowActivation_slider = this;
  SlideshowActivation_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Product Template Active
$.fn.productTemplate = function() {
  /* --------------------------------------------------------
            12. Product Details Page Media Gallery
        --------------------------------------------------------- */
  var $largeGallery = $('.ltn__shop-details-large-img');
  
  if ($largeGallery.length && $largeGallery.find('.single-large-img').length > 1) {
    if ($largeGallery.hasClass('slick-initialized')) {
      $largeGallery.slick('unslick');
    }
    $largeGallery.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow ltn__gallery-arrow-prev" aria-label="Previous"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow ltn__gallery-arrow-next" aria-label="Next"><i class="fas fa-chevron-right"></i></button>',
      fade: false,
      adaptiveHeight: true,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      touchThreshold: 10,
      speed: 350,
      infinite: false,
      cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
      
    });

    // Custom click logic to link thumbnail to large image slider
    $(document).off('click', '.ltn__shop-details-small-img .thumbnail-image').on('click', '.ltn__shop-details-small-img .thumbnail-image', function(e) {
      e.preventDefault();
      var index = $(this).closest('.single-small-img').index();
      if (index >= 0 && $largeGallery.hasClass('slick-initialized')) {
        $largeGallery.slick('slickGoTo', index);
        $('.ltn__shop-details-small-img .thumbnail-image').removeClass('active');
        $(this).addClass('active');
      }
    });

    // Custom slide change hook on the large slider to update active thumbnail
    $largeGallery.on('afterChange', function(event, slick, currentSlide) {
      var $thumbnails = $('.ltn__shop-details-small-img .thumbnail-image');
      $thumbnails.removeClass('active');
      $thumbnails.eq(currentSlide).addClass('active');
      
      var $activeThumb = $('.ltn__shop-details-small-img .single-small-img').eq(currentSlide);
      if ($activeThumb.length) {
        var container = $('.ltn__shop-details-small-img')[0];
        if (container) {
          var scrollLeft = $activeThumb[0].offsetLeft - (container.clientWidth / 2) + ($activeThumb[0].clientWidth / 2);
          container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
      }

      // Reset any active transforms on previous slide
      $('.ltn__shop-details-large-img .single-large-img img').css({
        'transform': 'scale(1)',
        'transform-origin': 'center center'
      });
      if (isZoomActive) {
        setZoomState(false);
      }
    });
  }

  // Dedicated Button-Activated Magnifier Zoom Mode
  var isZoomActive = false;
  var $gallery = $('.ltn__shop-details-img-gallery');

  function setZoomState(active, initialPos) {
    isZoomActive = active;
    var $activeSlide = $('.ltn__shop-details-large-img .slick-current .single-large-img, .ltn__shop-details-large-img .single-large-img:first-child');
    var $img = $activeSlide.find('img.product_variant_image, img');

    if (isZoomActive) {
      $gallery.addClass('is-zoom-active');
      $img.css({
        'transform': 'scale(2.3)',
        'transition': 'transform 0.25s cubic-bezier(0.25, 1, 0.5, 1)'
      });
      if (initialPos) {
        $img.css({
          'transform-origin': initialPos.x + '% ' + initialPos.y + '%'
        });
      }
    } else {
      $gallery.removeClass('is-zoom-active');
      $('.ltn__shop-details-large-img .single-large-img img').css({
        'transform': 'scale(1)',
        'transform-origin': 'center center',
        'transition': 'transform 0.25s ease-out'
      });
    }
  }

  // Click on "Zoom / Close" button to toggle zoom mode
  $(document).off('click', '.orewa-zoom-toggle-btn').on('click', '.orewa-zoom-toggle-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    setZoomState(!isZoomActive);
  });

  // Track cursor and magnify hovered part ONLY when zoom mode is active
  $(document).off('mousemove.orewazoom', '.ltn__shop-details-large-img .product-zoom').on('mousemove.orewazoom', '.ltn__shop-details-large-img .product-zoom', function(e) {
    if (!isZoomActive || window.innerWidth <= 768) return;
    var $img = $(this).find('img.product_variant_image, img');
    if (!$img.length) return;

    var rect = this.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
    var y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));

    $img.css({
      'transform': 'scale(2.3)',
      'transform-origin': x + '% ' + y + '%',
      'transition': 'none'
    });
  });

  // Click on image directly to toggle zoom on/off at that point
  $(document).off('click.orewazoom', '.ltn__shop-details-large-img .product-zoom').on('click.orewazoom', '.ltn__shop-details-large-img .product-zoom', function(e) {
    if (window.innerWidth <= 768) return;
    var rect = this.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
    var y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
    setZoomState(!isZoomActive, { x: x, y: y });
  });

  // Automatically reset zoom on slide navigation or thumbnail click
  $largeGallery.on('beforeChange', function() {
    if (isZoomActive) {
      setZoomState(false);
    }
  });

  $(window).on('resize.orewazoom', function() {
    if (window.innerWidth <= 768 && isZoomActive) {
      setZoomState(false);
    }
  });

  
  /* ==========================================================================
     OREWA Product Information Tabs Interactive Handlers
     ========================================================================== */
  // FAQ Accordion Toggle
  $(document).off('click.orewafaq', '.orewa-accordion-header').on('click.orewafaq', '.orewa-accordion-header', function(e) {
    e.preventDefault();
    var $item = $(this).closest('.orewa-accordion-item');
    var $body = $item.find('.orewa-accordion-body');
    
    $item.toggleClass('is-open');
    $body.stop(true, true).slideToggle(250);
  });

  // Full INCI Drawer Toggle
  $(document).off('click.orewainci', '.orewa-full-inci-toggle').on('click.orewainci', '.orewa-full-inci-toggle', function(e) {
    e.preventDefault();
    var $drawer = $(this).closest('.orewa-full-inci-drawer');
    var $content = $drawer.find('.orewa-full-inci-content');
    
    $drawer.toggleClass('is-open');
    $content.stop(true, true).slideToggle(250);
  });

  // Copy Full INCI List to Clipboard
  $(document).off('click.orewacopyinci', '#orewaCopyInciBtn').on('click.orewacopyinci', '#orewaCopyInciBtn', function(e) {
    e.preventDefault();
    var textToCopy = $('#orewa-inci-text-content').text().trim();
    if (!textToCopy) return;

    var $btn = $(this);
    var originalHtml = '<i class="fas fa-copy"></i> <span>Copy INCI List</span>';

    function setCopiedState() {
      $btn.addClass('is-copied').html('<i class="fas fa-check" style="color: #FFFFFF !important;"></i> <span style="color: #FFFFFF !important; font-weight: 700;">Copied!</span>');
      setTimeout(function() {
        $btn.removeClass('is-copied').html(originalHtml);
      }, 2200);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(setCopiedState).catch(setCopiedState);
    } else {
      var $temp = $('<textarea>');
      $('body').append($temp);
      $temp.val(textToCopy).select();
      document.execCommand('copy');
      $temp.remove();
      setCopiedState();
    }
  });

  // Mobile Tabs Horizontal Auto-Centering on Click
  $(document).off('click.orewatabscroll', '.orewa-nav-tabs .nav-link').on('click.orewatabscroll', '.orewa-nav-tabs .nav-link', function() {
    var $tab = $(this);
    var $container = $tab.closest('.orewa-nav-tabs');
    if ($container.length && window.innerWidth <= 991) {
      var scrollLeft = $tab.position().left + $container.scrollLeft() - ($container.width() / 2) + ($tab.outerWidth() / 2);
      $container.animate({ scrollLeft: scrollLeft }, 300);
    }
  });

  // Global Smooth Scroll to Product Info Tabs
  window.orewaScrollToTabs = function() {
    var $target = $('.orewa-product-tab-section, #orewa_tab_navs, .ltn__shop-details-tab-inner');
    if ($target.length) {
      // Ensure description tab is clicked / active
      var $descTab = $('#tab-nav-desc, [href="#orewa_tab_description"]');
      if ($descTab.length) {
        if (typeof $descTab.tab === 'function') {
          $descTab.tab('show');
        } else {
          $descTab.trigger('click');
        }
      }
      var offset = $target.first().offset().top - 90;
      $('html, body').stop().animate({ scrollTop: offset }, 600);
    }
  };
};

// Team Skill Active
$.fn.teamSkill = function() {
  /* --------------------------------------------------------
            14. LightCase jQuery Active
        --------------------------------------------------------- */
  $('a[data-rel^=lightcase]').lightcase({
    transition: 'elastic', /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */
    swipe: true,
    maxWidth: 1170,
    maxHeight: 600,
  });
  
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// Contact Form Active
$.fn.contactForm = function() {
  // 10. Nice Select
  $('.ltn__contact-message-area select').niceSelect();
};

// Our Journey Active
$.fn.ourJourney = function() {
  /* --------------------------------------------------------
            11. Default active and hover item active
        --------------------------------------------------------- */
  var ltn__active_item = $('.ltn__our-journey-wrap ul li')
  ltn__active_item.mouseover(function() {
    ltn__active_item.removeClass('active');
    $(this).addClass('active');
  });
};

// Pricing Table Active
$.fn.pricingTable = function() {
  /* --------------------------------------------------------
            11. Default active and hover item active
        --------------------------------------------------------- */
  var ltn__active_item = $('.ltn__pricing-plan-item')
  ltn__active_item.mouseover(function() {
    ltn__active_item.removeClass('active');
    $(this).addClass('active');
  });
};

// Countdown Banner Active
$.fn.passwordPage = function() {
  /* --------------------------------------------------------
            29. Countdown
        --------------------------------------------------------- */
  $('.ltn__coming-soon-area [data-countdown].ltn__countdown').each(function () {

    var $this = $(this),
        finalDate = $(this).data('countdown');
    if (!$this.hasClass('countdown-full-format')) {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h1>%D</h1><p>Days</p></div> <div class="single"><h1>%H</h1><p>Hrs</p></div> <div class="single"><h1>%M</h1><p>Mins</p></div> <div class="single"><h1>%S</h1><p>Secs</p></div>'));
      });
    } else {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h1>%Y</h1><p>Years</p></div> <div class="single"><h1>%m</h1><p>Months</p></div> <div class="single"><h1>%W</h1><p>Weeks</p></div> <div class="single"><h1>%d</h1><p>Days</p></div> <div class="single"><h1>%H</h1><p>Hrs</p></div> <div class="single"><h1>%M</h1><p>Mins</p></div> <div class="single"><h1>%S</h1><p>Secs</p></div>'));
      });
    }

  });
};

// Featured product active js
$.fn.featuredProduct = function() {
  $('.featured-product [data-countdown]').each(function () {
    var $this = $(this),
        finalDate = $(this).data('countdown');
    if (!$this.hasClass('countdown-full-format')) {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%D</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    } else {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%Y</h6><p>Years</p></div> <div class="single"><h6>%m</h6><p>Months</p></div> <div class="single"><h6>%W</h6><p>Weeks</p></div> <div class="single"><h6>%d</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    }
  });
};

// Countdown Banner 2 Active
$.fn.countdownBanner2 = function() {
  /* --------------------------------------------------------
            29. Countdown
        --------------------------------------------------------- */
  $('[data-countdown].ltn__countdown-3').each(function () {

    var $this = $(this),
        finalDate = $(this).data('countdown');
    if (!$this.hasClass('countdown-full-format')) {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%D</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    } else {
      $this.countdown(finalDate, function (event) {
        $this.html(event.strftime('<div class="single"><h6>%Y</h6><p>Years</p></div> <div class="single"><h6>%m</h6><p>Months</p></div> <div class="single"><h6>%W</h6><p>Weeks</p></div> <div class="single"><h6>%d</h6><p>Days</p></div> <div class="single"><h6>%H</h6><p>Hrs</p></div> <div class="single"><h6>%M</h6><p>Mins</p></div> <div class="single"><h6>%S</h6><p>Secs</p></div>'));
      });
    }

  });
};

// Search Inventory 3 Active
$.fn.heroBanner2 = function() { 
  var SlideshowActivation_slider = this;
  SlideshowActivation_slider.slick({
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  
  // 7. Background Image
  var $backgroundImage = $('.bg-image');
  $backgroundImage.each(function() {
    var $this = $(this),
        $bgImage = $this.data('bg');
    $this.css('background-image', 'url('+$bgImage+')');
  });
};

// 15. Slider + Category Menu
$.fn.slideshowCategoryMenu = function() {
  var slideshowCategoryMenu_slider = this;
  slideshowCategoryMenu_slider.slick({
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
  
  
  /* --------------------------------------------------------
    3-2. Category Menu
--------------------------------------------------------- */

  $('.ltn__category-menu-title').on('click', function(){
    $('.ltn__category-menu-toggle').slideToggle(500);
  });	

  /* Category Menu More Item show */
  $('.ltn__category-menu-more-item-parent').on('click', function(){
    $('.ltn__category-menu-more-item-child').slideToggle();
    $(this).toggleClass('rx-change');

  });

  /* Category Submenu Column Count */
//   $('.ltn__category-submenu').each(function(){
//     if($(this).children('li').length){
//       var ulChildren = $(this).children('li').length;
//       $(this).addClass('ltn__category-column-no-'+ulChildren)
//     }
//   });

  /* Category Menu Responsive */
  function ltn__CategoryMenuToggle(){
    $('.ltn__category-menu-toggle .ltn__category-menu-drop > a').on('click', function(){
      if($(window).width() < 991){
        $(this).removeAttr('href');
        var element = $(this).parent('li');
        if (element.hasClass('open')) {
          element.removeClass('open');
          element.find('li').removeClass('open');
          element.find('ul').slideUp();
        }
        else {
          element.addClass('open');
          element.children('ul').slideDown();
          element.siblings('li').children('ul').slideUp();
          element.siblings('li').removeClass('open');
          element.siblings('li').find('li').removeClass('open');
          element.siblings('li').find('ul').slideUp();
        }
      }
    });
    $('.ltn__category-menu-toggle .ltn__category-menu-drop > a').append('<span class="expand"></span>');
  }
  ltn__CategoryMenuToggle();
  
};


// 17. Small Product Slider One
$.fn.featuredCollectionList2 = function() {
  var $featuredCollectionList2Slider = this;
  $featuredCollectionList2Slider.slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
};


// Category Slider 2
$.fn.categoryList2 = function() {
  var $categoryList2Slider = this;
  $categoryList2Slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// Category Slider 3
$.fn.categoryList3 = function() {
  var $categoryList3Slider = this;
  $categoryList3Slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};

// Category Slider 3
$.fn.collectionTemplate = function() {
   /* Slidebar collapse */ 
  $('.widget-collapse .ltn__widget-title').on("click", function(){
    $(this).siblings('.widget-collapse-hide').slideToggle();
    $(this).toggleClass('widget-collapse-show');
  });

  $('.collection-filter-title').on("click", function(){
    $(this).siblings('.filter-collapse-hide').slideToggle();
    $(this).toggleClass('filter-collapse-show');
  });
  
  $('input[type="checkbox"]').click(function() {
    setTimeout(function() {
      $('form[name="storefrontfilter"]').submit();
    }, 500);
  });

  // Filter Drawer
  $('.collection-filter-drawer-title').on('click', function() {
      $('.ltn__utilize-cart-menu').addClass('ltn__utilize-open');
      $('body').addClass('ltn__utilize-open');
      $('.ltn__utilize-overlay').fadeIn();
  });
};

// 15. Slider One Active
$.fn.slideshowThreeActivation = function() {
  var $slideshowThreeActivation_slider = this;
  $slideshowThreeActivation_slider.slick({
    arrows: true,
    autoplaySpeed: 5000,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          dots: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: true,
        }
      }
    ]
  }).on('afterChange', function(){
    if (typeof WOW !== 'undefined') new WOW().init();
  });
};


// Testimonial Slider Four
$.fn.testimonialSliderFour = function() {
  var $testimonialSliderFour_slider = this;
  $testimonialSliderFour_slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>',
    
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
};


// Category Slider 2
$.fn.allCategoryList = function() {
  var $allCategoryListSlider = this;
  $allCategoryListSlider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    
    prevArrow: '<a class="slick-prev"><i class="fas fa-chevron-left"></i></a>',
    nextArrow: '<a class="slick-next"><i class="fas fa-chevron-right"></i></a>'
    
  });
};


(function($) {
  "use strict";

  jQuery(document).ready(function(){

    /* --------------------------------------------------------
            1. Variables
        --------------------------------------------------------- */
    var $window = $(window),
        $body = $('body');




    /* ---------------------------------------------------------
            8. wow js init
        --------------------------------------------------------- */
    if (typeof WOW !== 'undefined') {
      new WOW().init();
    }


    /* ---------------------------------------------------------
            9. Tooltip
        --------------------------------------------------------- */
    if ($.fn.tooltip) {
      $('[data-toggle="tooltip"]').tooltip();
    }


    /* --------------------------------------------------------
            10. Nice Select
        --------------------------------------------------------- 
        $('select').niceSelect();

        */ 


    /* --------------------------------------------------------
            33. Quantity plus minus
        -------------------------------------------------------- */
    $('.quantity').each(function() {
      var spinner = jQuery(this);
      if (!spinner.find('.qtybutton').length) {
        jQuery('<div class="quantity-button quantity-down dec qtybtn qtybutton">-</div>').insertBefore(spinner.find('input'));
        jQuery('<div class="quantity-button quantity-up inc qtybtn qtybutton">+</div>').insertAfter(spinner.find('input'));
      }
    });

    $(document).on('click', '.dec.qtybutton, .quantity-down', function(e) {
      e.preventDefault();
      var spinner = $(this).closest('.quantity, .cart-plus-minus'),
          input = spinner.find('input[type="text"], input.cart-plus-minus-box, input[name="quantity"], input[name="updates[]"]'),
          min = parseFloat(input.attr('min')) || 1,
          oldValue = parseFloat(input.val()) || 1;
      var newVal = (oldValue <= min) ? min : (oldValue - 1);
      input.val(newVal);
      input.trigger('change');
    });

    $(document).on('click', '.inc.qtybutton, .quantity-up', function(e) {
      e.preventDefault();
      var spinner = $(this).closest('.quantity, .cart-plus-minus'),
          input = spinner.find('input[type="text"], input.cart-plus-minus-box, input[name="quantity"], input[name="updates[]"]'),
          max = parseFloat(input.attr('max')) || 999999,
          oldValue = parseFloat(input.val()) || 1;
      var newVal = (oldValue >= max) ? oldValue : (oldValue + 1);
      input.val(newVal);
      input.trigger('change');
    });

    // Product grid color variant activation code. 
    $('.product-color li.grid-swatch-selector label').click(function(){
      $('li.grid-swatch-selector label').removeClass("active");
      jQuery(this).addClass('active');
      var variantURL = jQuery(this).parent().find('.product-url a').attr('href');
      
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage, srcset: variantImage }); 

      jQuery(this).parents('.product-wrapper').find('.product-title a').attr({ href: variantURL });
      jQuery(this).parents('.product-wrapper').find('.product-img > a').attr({ href: variantURL });
      return false;
    });

    // Cart Drawer
    $('.ajax-spin-cart-drawer').on('click', function() {
      setTimeout(function () {
        $('#ltn__utilize-cart-menu').addClass('ltn__utilize-open');
        $('body').addClass('ltn__utilize-open');
        $('.ltn__utilize-overlay').fadeIn();
      },1000);
    });

    /* ----------------------------
        AOS Scroll Animation 
    -------------------------------*/
    if (typeof AOS !== 'undefined') {
      AOS.init({
        offset: 10,
        duration: 1000,
        once: true,
        easing: 'ease',
      });
    }
    // Delegated listener for Orewa Pincode Delivery Checker
    $(document).on('click', '.orewa-pincode-btn', function(e) {
      e.preventDefault();
      if (typeof window.checkOrewaPincode === 'function') {
        window.checkOrewaPincode(this);
      }
    });

    $(document).on('keypress', '.orewa-pincode-input', function(e) {
      if (e.which === 13) {
        e.preventDefault();
        if (typeof window.checkOrewaPincode === 'function') {
          window.checkOrewaPincode(this);
        }
      }
    });
  });

  /* --------------------------------------------------------
     OREWA Dynamic Review Submission & Star Rating Interaction
  --------------------------------------------------------- */
  window.selectReviewStars = function(rating) {
    var container = document.querySelector('.orewa-star-picker');
    if (!container) return;
    var stars = container.querySelectorAll('.star-opt');
    stars.forEach(function(star, index) {
      if (index < rating) {
        star.classList.add('active');
      } else {
        star.classList.remove('active');
      }
    });
    var input = document.getElementById('orewaReviewRatingInput');
    if (input) input.value = rating;
  };

  /* --------------------------------------------------------
     OREWA 260+ Verified Indian Reviews Dynamic Pagination Manager
  --------------------------------------------------------- */
  window.orewaReviewsPerPage = 8;
  window.orewaReviewsCurrentPage = 1;
  window.allOrewaReviews = [];

  window.initOrewaReviews = function() {
    var rawJsonEl = document.getElementById('orewaReviewsJsonData');
    var baseReviews = [];
    if (rawJsonEl) {
      try {
        baseReviews = JSON.parse(rawJsonEl.textContent);
      } catch(e) {}
    }

    var prodId = window.orewaCurrentProductId || 'default';
    var userReviews = [];
    try {
      userReviews = JSON.parse(localStorage.getItem('orewa_user_reviews_' + prodId) || '[]');
    } catch(e) {}

    window.allOrewaReviews = userReviews.concat(baseReviews);
    window.renderOrewaReviewsPage(1, false);
  };

  window.renderOrewaReviewsPage = function(page, shouldScroll) {
    var total = window.allOrewaReviews.length;
    if (total === 0) return;
    var perPage = window.orewaReviewsPerPage;
    var totalPages = Math.ceil(total / perPage);
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    window.orewaReviewsCurrentPage = page;

    var startIdx = (page - 1) * perPage;
    var endIdx = Math.min(startIdx + perPage, total);
    var currentBatch = window.allOrewaReviews.slice(startIdx, endIdx);

    var feed = document.getElementById('orewaReviewsFeed');
    if (!feed) return;

    var html = '';
    currentBatch.forEach(function(r) {
      var firstLetter = (r.author || r.name || 'V').charAt(0).toUpperCase();
      var starsHtml = '';
      var rating = r.rating || 5;
      for (var i = 0; i < rating; i++) { starsHtml += '★'; }

      html += '<div class="orewa-review-card" style="animation: fadeIn 0.3s ease forwards;">' +
        '<div class="orewa-review-header">' +
          '<div class="orewa-reviewer-info">' +
            '<div class="orewa-reviewer-avatar">' + firstLetter + '</div>' +
            '<div class="orewa-reviewer-meta">' +
              '<div class="orewa-reviewer-name-row">' +
                '<h5 class="orewa-reviewer-name">' + (r.author || r.name) + '</h5>' +
                '<span class="orewa-verified-badge"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> Verified Buyer</span>' +
              '</div>' +
              '<span class="orewa-reviewer-location">' + (r.location || 'India') + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="orewa-review-rating-col">' +
            '<div class="orewa-stars-gold">' + starsHtml + '</div>' +
            '<span class="orewa-review-date">' + (r.date || 'Recently') + '</span>' +
          '</div>' +
        '</div>' +
        '<h4 class="orewa-review-title">' + (r.title || r.headline || '') + '</h4>' +
        '<p class="orewa-review-comment">' + (r.comment || r.feedback || '') + '</p>' +
        '<div class="orewa-review-footer">' +
          '<span class="orewa-helpful-prompt">Was this review helpful?</span>' +
          '<button type="button" class="orewa-helpful-btn" onclick="this.classList.toggle(\'active\');"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg> Yes</button>' +
        '</div>' +
      '</div>';
    });

    feed.innerHTML = html;

    // Progressive Unlocking Pagination Logic (1-4, then +2 progressively)
    if (!window.orewaReviewsMaxUnlockedPage || window.orewaReviewsMaxUnlockedPage < 4) {
      window.orewaReviewsMaxUnlockedPage = Math.min(4, totalPages);
    }
    if (page >= window.orewaReviewsMaxUnlockedPage) {
      window.orewaReviewsMaxUnlockedPage = Math.min(totalPages, page + 2);
    }

    var pagContainer = document.getElementById('orewaReviewsPagination');
    if (pagContainer) {
      var pagHtml = '<div class="orewa-pagination-info">Showing ' + (startIdx + 1) + ' – ' + endIdx + ' of ' + total + ' verified customer reviews</div>';
      pagHtml += '<div class="orewa-pagination-buttons">';

      // Prev Button
      pagHtml += '<button type="button" class="orewa-page-nav-btn" onclick="window.renderOrewaReviewsPage(' + (page - 1) + ', true)" ' + (page === 1 ? 'disabled' : '') + '><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg> Previous</button>';

      // Render Progressive Page Buttons (1 up to maxUnlockedPage)
      var maxUnlocked = window.orewaReviewsMaxUnlockedPage;
      var startPage = 1;
      
      // If unlocked pages grow large, keep a smooth window with 1 always accessible
      if (maxUnlocked > 7 && page > 4) {
        startPage = Math.max(1, page - 3);
        if (startPage > 1) {
          pagHtml += '<button type="button" class="orewa-page-btn" onclick="window.renderOrewaReviewsPage(1, true)">1</button>';
          if (startPage > 2) pagHtml += '<span class="orewa-page-ellipsis">...</span>';
        }
      }

      for (var p = startPage; p <= maxUnlocked; p++) {
        pagHtml += '<button type="button" class="orewa-page-btn ' + (p === page ? 'active' : '') + '" onclick="window.renderOrewaReviewsPage(' + p + ', true)">' + p + '</button>';
      }

      // Next Button (Takes user to next page, unlocking more dynamically)
      pagHtml += '<button type="button" class="orewa-page-nav-btn" onclick="window.renderOrewaReviewsPage(' + (page + 1) + ', true)" ' + (page === totalPages ? 'disabled' : '') + '>Next <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg></button>';

      pagHtml += '</div>';
      pagContainer.innerHTML = pagHtml;
    }

    if (shouldScroll) {
      var tabsEl = document.getElementById('orewa_tab_reviews') || document.querySelector('.orewa-product-tab-section');
      if (tabsEl) tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  window.submitOrewaReview = function(form) {
    var formData = new FormData(form);
    var name = formData.get('name') || 'Verified Customer';
    var location = formData.get('location') || 'India';
    var rating = parseInt(formData.get('rating') || 5, 10);
    var headline = formData.get('headline') || '';
    var feedback = formData.get('feedback') || '';

    var newReviewObj = {
      author: name,
      name: name,
      location: location,
      rating: rating,
      title: headline,
      headline: headline,
      comment: feedback,
      feedback: feedback,
      date: 'Just now'
    };

    try {
      var prodId = window.orewaCurrentProductId || 'default';
      var saved = JSON.parse(localStorage.getItem('orewa_user_reviews_' + prodId) || '[]');
      saved.unshift(newReviewObj);
      localStorage.setItem('orewa_user_reviews_' + prodId, JSON.stringify(saved));
    } catch(e) {}

    window.allOrewaReviews.unshift(newReviewObj);
    window.renderOrewaReviewsPage(1, true);

    var counts = document.querySelectorAll('.orewa-tab-count, .orewa-summary-count, .orewa-rating-count, .orewa-card-count');
    counts.forEach(function(el) {
      var txt = el.textContent;
      var num = parseInt(txt.replace(/\D/g, ''), 10);
      if (!isNaN(num)) {
        el.textContent = txt.replace(num.toString(), (num + 1).toString());
      }
    });

    form.style.display = 'none';
    var success = document.getElementById('orewaReviewSuccessMsg');
    if (success) success.style.display = 'block';
  };

  // Initialize reviews on DOM ready
  $(function() {
    window.initOrewaReviews();
  });

})(jQuery);